<template>
    <div id="jatekszabaly" class="rules position-relative block--big">
        <div class="container-xl">

            <div class="row px-2">
                <h2 class="text-secondary text-center mb-6 mb-md-7 pb-md-6">
                    A játék lépései
                </h2>
                <div class="col-12 mb-5 py-0 d-flex align-items-start justify-content-start flex-wrap flex-md-nowrap flex-column flex-md-row" style="gap:10px;" >
                    <div class="rules-container-custom" v-for="(tab, tabind) in tabs" :key="tabind">
                        <img                         
                            :src="tab.id == activeTab ? tab.img : tab.img"
                            class="img-fluid mx-auto d-block" 
                            alt="szabályok"
                            style="cursor:pointer;"
                        >
                        <div class="text-center fw-700 fs-22 text-secondary mt-4">{{tab.name}}</div>
                        <p class="text-primary text-center fs-16" v-html="tab.content[0][1]"></p>
                    </div>
                </div>
                    <!-- desctop -->
                  <!--  <ul 
                        class="rules-buttons nav nav-pills justify-content-center d-none d-sm-flex w-100 pt-4" 
                        id="pills-tab" 
                        role="tablist">
                        <li 
                            v-for="(tab, tabind) in tabs"
                            :key="'tab-button-' + tab.id" 
                            role="presentation"
                            class="d-flex justify-content-center align-items-start">
                            <div 
                                class="rules-tab-button d-flex align-items-center" 
                                :class="tab.id == 1 ? 'active' : ''"
                                @click="setActiveTab(tab.id)"
                                data-bs-toggle="pill"
                                :data-bs-target="'#pills-' + tab.id"
                                role="tab"
                                aria-selected="true"
                            >
                                <div class="rules-tab-button-content d-flex flex-column">
                                    <div class="d-flex justify-content-center">
                                        <div class="rules-img text-center">-->
                                            <!-- tab.imgActive -->
                                           <!-- <img 
                                                 
                                                :src="tab.id == activeTab ? tab.img : tab.img"
                                                class="img-fluid" 
                                                alt="szabályok"
                                                style="cursor:pointer;"
                                            >
                                            <div class="rule-main-step-img" :class="`rule-main-step-img--${tab.id}`"></div>
                                            <div class="text-center fw-700 fs-22 text-primary mt-4" :style="tab.id == activeTab ? '' : 'opacity:0.4'">{{tab.name}}</div>
                                        </div>                                        
                                    </div>                                   
                                </div>
                                
                            </div>
                            <img v-if="tabind < tabs.length - 1" src="@/assets/imgs/step-sep.svg" class="mx-4" style="margin-top:30px"/>
                        </li>
                    </ul>-->
                    <!-- desctop -->
                   <!-- <div 
                        class="tab-content flex-1 d-none d-sm-block mt-5" 
                        id="pills-tabContent">                        
                            <div
                                v-for="tab in tabs"
                                :key="'tab-content-' + tab.id" 
                                class="tab-pane fade"
                                :class="tab.id == 1 ? 'show active' : ''" 
                                :id="'pills-' + tab.id" 
                                role="tabpanel" 
                                aria-labelledby="'pills-'+ tab.id + '-tab'"
                            >
                                <div 
                                    class="rules-tab-content d-flex align-items-center"
                                    :class="content[2] == '1' || content[2] == '3' || content[2] == '4' || content[2] == '6' || content[2] == '7' ? 'add-border w-100':''"
                                    v-for="(content, i) in tab.content" :key="i"
                                >  
                                    <p class="font-main m-0 text-primary me-3 fw-700 pb-4 fs-30 fs-md-60"> -->
                                        <!-- <img :src="'imgs/'+content[0]" width="45" height="45"> -->
                                      <!--  {{content[2]}}
                                    </p>
                                    <p class="text-black py-3 m-0" 
                                        v-html="content[1]"
                                        ></p>
                                </div>
                        </div>
                    </div>-->

                    <!-- MOBILE -->
                   <!-- <div id="gameRuleCarousel" class="carousel slide d-block d-sm-none" data-bs-ride="carousel">                        
                        <div class="carousel-inner" >
                            <div class="carousel-item" data-bs-interval="8000"
                                :class="tab.id == 1 ? 'active' : ''"
                                v-for="tab in tabs"
                                :key="tab.id" >
                                <div class="rules-img rules-img--mobile text-center">
                                    <img 
                                        :src="tab.img" 
                                        class="img-fluid" 
                                        :alt="tab.name"
                                    >
                                    <div class="rule-main-step-img" :class="`rule-main-step-img--${tab.id}`"></div>
                                    <div class="text-center fw-700 fs-22 text-primary mt-4 mb-4">{{tab.name}}</div>
                                </div>
                                
                                <div class="rules-tab-content d-flex align-items-center justify-content-center font-secondary mb-4"
                                        v-for="(content, i) in tab.content" :key="i">
                                    <div class="d-flex justify-content-center flex-column align-items-center align-items-md-start"
                                        :class="content[2] == '1' || content[2] == '3' || content[2] == '4' || content[2] == '6' || content[2] == '7' ? 'add-border w-100':''"
                                    >  
                                        <p class="font-main m-0 text-primary me-3 pb-4 fw-700 fs-30 fs-md-60">-->
                                            <!-- <img :src="'imgs/'+content[0]" width="40" height="40"> -->
                                          <!--  {{content[2]}}
                                        </p>
                                        <p class="text-black pb-4 m-0" 
                                            v-html="content[1]" 
                                            
                                        ></p>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button class="carousel-control-prev" type="button" data-bs-target="#gameRuleCarousel" data-bs-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Previous</span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#gameRuleCarousel" data-bs-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Next</span>
                        </button>
                    </div>
                </div>     -->    
                <div class="col-12 text-center mt-5">
                    <div class="text-white good-luck fw-700 fs-24">Jó játékot, sok szerencsét kívánunk!</div>
                </div>
                <!-- BUTTONS      -->
                <div class="col-12 flex-wrap flex-md-nowrap justify-content-center d-flex py-7">
                    <button
                        class="btn btn-secondary mb-4 mb-md-0 me-0 me-md-4"
                        v-scroll-to="{el:!$store.state.user ? '#regisztracio' : '#palyazat',  offset: -80}"
                        @click="setGtm('Játszom')"
                    >
                        Játszom
                    </button>
                    <a class="btn btn-secondary--outline " :href="$store.state.file_url" target="_blank" @click="setGtm('Játékszabályzat')">
                        Játékszabályzat
                    </a> 
                </div>  
                
                
            </div> <!-- end of ROW -->
        </div>        
    </div>
</template>

<script>
export default {
    data () {
        return {
            activeTab: 1,
             tabs: [ 
                {
                    id: 1,
                    name: "Vásárolj",
                    img: "imgs/vasarolj.svg",
                    imgActive: "imgs/vasarolj-active.svg",
                    content:[
                        ["step-1.svg",`egyszerre legalább <b>4 db a promócióban részt vevő Gösser Natur Zitrone</b> terméket a magyarországi <b>ALDI</b> áruházakban.`, "1"],
                    ]
                   

                },
                {
                    id: 2,
                    name: "Töltsd fel",
                    img: "imgs/regisztralj.svg",
                    imgActive: "imgs/regisztralj-active.svg",
                    content: [
                        [
                            "step-3.svg","a <b>vásárlást igazoló bizonylat adatait</b> miután bejelentkeztél. <b>Ha minden héten töltesz fel blokkot, indulhatsz az extra nyereményért is!</b>", "3"
                        ]                       
                    ]
                    
                },
                {
                    id: 3,
                    name: "Őrizd meg",
                    img: "imgs/orizd.svg",
                    imgActive: "imgs/nyerj-active.svg",
                    content: [
                       
                        [
                            "step-6.svg","<b>2024. augusztus 17-ig</b> a vásárlást igazoló eredeti bizonylatot sértetlen, ép állapotban.", "6"
                        ]
                    ]
                    
                },
                {
                    id: 4,
                    name: "Nyerd meg",
                    img: "imgs/nyerj.svg",
                    imgActive: "imgs/nyerj-active.svg",
                    content: [
                       
                        [
                            "step-6.svg","az <b>értékes nyereményeket!</b>", "6"
                        ]
                    ]
                    
                }               
            ]
        }
    },
    methods:{
        setGtm(btnName){
            this.GTtrackGA4({
                'event' : 'event',
                'category': 'jatekleiras',
                'action': 'gomb_kattintas',
                'label': btnName,                
                'clicked_text':btnName,
                'action_type': 'gomb_kattintas'
            })
        },
        setActiveTab(index){
            this.activeTab = index;
        }
    }
}
</script>